import Header from "./Components/Header/Header";
import UpperSection from "./Components/Upper_Section/UpperSection";
import MiddleSection from "./Components/Middle Section/MiddleSection";
import LowerSection from "./Components/Lower Section/LowerSection";
import FooterSection from "./Components/Footer Section/FooterSection";
function App() {
  return (
    <>
      <Header />
      <UpperSection />
      <MiddleSection />
      <LowerSection />
      <FooterSection />
    </>
  );
}

export default App;
